<template>
<div id="report-style" >
  <div style="height: 125px;"></div>
  <div id="report-to-print" class="d-flex .flex-*-fill flex-column bd-highlight">
    <div id="report-head" class="d-flex flex-column bd-highlight">
      <div class="d-flex flex-row bd-highlight">
        <div id="report-image" alt="logo"></div>
        <div id="report-header" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-2 bd-highlight"><b>PT. UNILEVER OLEOCHEMICAL INDONESIA</b></div>
          <div class="p-2 bd-highlight"><b><i>FORM KELUHAN PELANGGAN</i></b></div>
          <div class="p-2 bd-highlight"><b><i>CUSTOMER COMPLAINT FORM</i></b></div>
        </div>
        <div id="report-sidebar" class="d-flex flex-fill flex-column bd-highlight">
          <div id="sidebar-border" class="p-1 bd-highlight">No Dok<br/>Ref</div>
          <div id="sidebar-border" class="p-1 bd-highlight">No Terbitan<br/>Issue No</div>
          <div id="sidebar-border" class="p-1 bd-highlight">Halaman<br/>Page No</div>
        </div>
        <div id="report-sidebar" class="d-flex flex-fill flex-column bd-highlight">
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>UOI-F-TS-001</div>
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>01.1</div>
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>1 of 1</div>
        </div>
      </div>
    </div>
    
    <div id="borderline"></div>

    <!-- NO 1 -->
    <div id="report-body2" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>1. DETAIL KONTAK<br/>CONTACT DETAILS</b></div>
        <!-- <div class="p-1 bd-highlight">{{ccf.srNumber}}</div> -->
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">No Komplain<br/>Complaint No</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.complaintNo}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Tanggal Diterima<br/>Receiving Date</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{moment(ccf.reportedDate).format("DD-MMM-YYYY")}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Pelanggan<br/>Customer</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.customerName}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body-new" class="d-flex flex-fill flex-column bd-highlight" style="height: 100px; padding-top: 20px">
        <div class="p-1">Alamat<br/>Address</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.address}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Tel./Fax No.<br/>Tel./Fax No.</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.phone}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">PIC<br/>PIC</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.pic}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Email<br/>Email</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.email}}</div>
      </div>
    </div>
    <div id="borderline"></div>

    <br/>

    <!-- NO 2 -->
    <div id="borderline"></div>
    <div id="report-body2" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>2. DETAIL PENGADUAN PRODUK/ DOKUMENTASI<br/>COMPLAINT PRODUCT / DOCUMENTATION DETAILS</b></div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight" style="height: 70px; padding-top: 10px">
        <div class="p-1">Merk<br/>Brand</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.productName}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight" style="height: 70px; padding-top: 10px">
        <div class="p-1">Produk<br/>Product</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.productName}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between" >
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight" style="height: 250px; padding-top: 100px">
        <div>Kode SAP / No. Contract<br/>SAP Code / Contract No.</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">
          PO : {{ccf.po}}<br/>
          SO : {{ccf.so}}<br/>
          Batch : {{ccf.batch}}<br/>
        </div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Jumlah<br/>Qty</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.qty}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Tgl Bl / Tgl Kirim<br/>B/L Date / Delivery Date</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{moment(ccf.blDate).format("DD-MMM-YYYY")}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Pelabuhan Bongkar / Tujuan Pengiriman<br/>Discharge Port / Delivery Destination</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.dischargePortName}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Negara<br/>Country</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.countryName}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">No Kontainer<br/>Container No</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.containerNo}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Model Pengiriman<br/>Model of Delivery</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.modelOfDeliveryName}}</div>
      </div>
    </div>
    
    <div id="borderline"></div>

    <div style="height: 180px;">
    </div>

    <!-- NO 3 -->
    <div id="borderline"></div>
    <div id="report-body2" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>3. JENIS PENGADUAN<br/>NATURE OF COMPLAINT</b></div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight" style="height: 930px; padding-top: 300px">
        <div class="p-1">Jenis ketidaksesuaian<br/>Non - Conformance Type</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">A. Kualitas / Quality</div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.conformanceTypeName === 'Quality - Physical & Chemical Properties'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Quality - Physical & Chemical Properties'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Properti Fisik & Kimia <br/> Physical & Chemical Properties</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group">
                <div v-if="ccf.conformanceTypeName === 'Quality - Foreign Matter & Contamination'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Quality - Foreign Matter & Contamination'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Benda Asing & Kontaminasi <br/> Foreign Matter & Contamination</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.conformanceTypeName === 'Quality - Applications'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Quality - Applications'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Aplikasi / Applications</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.conformanceTypeName === 'Quality - Customer Sensory (Appearance, Odor, Specks, etc.)'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Quality - Customer Sensory (Appearance, Odor, Specks, etc.)'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline"> Sensori Pelanggan (Penampilan, Bau, Bintik, dll.) <br/> Customer Sensory (Appearance, Odor, Specks, etc.)</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Lainnya, Sebutkan<br/>Others, please specify : moldy pallets</label>
              </div>
            </div>
          </div>
        </div>
        <div class="p-1">B. Pengemasan / Packaging</div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.conformanceTypeName === 'Packaging - Accessories (Pallet, Heating Pad, etc.)'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Packaging - Accessories (Pallet, Heating Pad, etc.)'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Aksesoris (Pallet, Bantalan Pemanas, dll.) <br/> Accessories (Pallet, Heating Pad, etc.)</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.conformanceTypeName === 'Packaging - Marking'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Packaging - Marking'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Tanda / Marking</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.conformanceTypeName === 'Packaging - Damaged'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Packaging - Damaged'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Kerusakan / Damaged</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.conformanceTypeName === 'Packaging - Incorrect Products'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Packaging - Incorrect Products'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Kesalahan Produk / Incorrect Products</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Lainnya, Sebutkan<br/>Others, please specify : moldy pallets</label>
              </div>
            </div>
          </div>
        </div>
        <div class="p-1">C. Service</div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.conformanceTypeName === 'Service - Late Product Shipment'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Service - Late Product Shipment'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Pengiriman Terlambat / Late Product Shipment</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.conformanceTypeName === 'Service - Documents'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Service - Documents'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Dokumen / Documents</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.conformanceTypeName === 'Service - Logistics (Container/Isotank issue, Seal, etc.)'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Service - Logistics (Container/Isotank issue, Seal, etc.)'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Logistik (Masalah Wadah/Isotank, Seal, dll.) <br/> Logistics (Container/Isotank issue, Seal, etc.)</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.conformanceTypeName === 'Service - Weight Deviation & Shortage'" id="box-filled"></div>
                <div v-if="ccf.conformanceTypeName !== 'Service - Weight Deviation & Shortage'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Penyimpangan & Kekurangan Berat <br/> Weight Deviation & Shortage</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Lainnya, Sebutkan<br/>Others, please specify : moldy pallets</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="borderline-body"></div>

    <br/>
    <br/>
    
    <!-- NO 4 -->
    <div id="borderline"></div>
    <div id="report-body2" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>4. INFORMASI LAIN<br/>OTHER INFORMATION</b></div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight" style="height: 180px; padding-top: 70px">
        <div class="p-1">Terlampir<br/>Enclosed</div>
      </div>
      <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.enclosedName === 'Document'" id="box-filled"></div>
                <div v-if="ccf.enclosedName !== 'Document'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Dokumen / Document</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.enclosedName === 'Sample'" id="box-filled"></div>
                <div v-if="ccf.enclosedName !== 'Sample'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Contoh / Sample</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div v-if="ccf.enclosedName === 'Picture'" id="box-filled"></div>
                <div v-if="ccf.enclosedName !== 'Picture'" id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Gambar / Picture</label>
              </div>
            </div>
          </div>
        </div>
        <div id="report-title-data" class="d-flex flex-fill flex-column bd-highlight">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group input-group-sm">
                <div id="box-blank"></div>
                <label style="margin-top: 0.5rem; margin-left: 1rem;" class="checkbox-inline">Bukti lain, sebutkan<br/>Other evidence, pleace specify : </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="borderline"></div>

    <br/>
    <br/>

    <!-- NO 5 -->
    <div id="borderline"></div>
    <div id="report-body2" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>5. DESKRIPSI KELUHAN<br/>COMPLAINT DESCRIPTION</b></div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight" style="height: 180px;">
        <div class="p-1"><br/>{{ccf.description}}<br/><br/></div>
      </div>
    </div>
    <div id="borderline"></div>

    <div style="height: 100px;">
    </div>

    <!-- NO 6 -->
    <div id="borderline"></div>
    <div id="report-body2" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>6. OTORISASI PENDAFTARAN KELUHAN (No. 1 - 5)<br/>COMPLAINT REGISTRATION AUTHORIZATION (No. 1 - 5)</b></div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div style="font-weight: bold;" class="p-1">Nama<br/>Name</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div style="font-weight: bold;" class="p-1">TTD & Cap<br/>Sign & Stamp</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div style="font-weight: bold;" class="p-1">Tanggal<br/>Date</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Disiapkan oleh<br/>Prepared by</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"><br />{{ccf.salesApprovedName}}</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Disetujui oleh<br/>Approved by</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"><br />{{ccf.salesApprovedName}}</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
    </div>
    <div id="borderline"></div>

    <br/>

    <!-- NO 7 -->
    <div id="borderline"></div>
    <div id="report-body2" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>7. RINCIAN INVESTIGASI<br/>INVESTIGATION DETAILS</b></div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">
          <br/>
          <ul>
            <li v-for="item in ccf.correctivePreventiveInternal" :key="item.rootCauseRemarkExternal">
              {{ item.rootCauseRemarkExternal }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div id="borderline"></div>

    <br/>

    <!-- NO 8 -->
    <div id="borderline"></div>
    <div id="report-body2" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>8. PERBAIKAN / TINDAKAN PENCEGAHAN YANG DIAMBIL<br/>CORRECTIVE / PREVENTIVE ACTIONS TAKEN</b></div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-title-body" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">
          <br/>
          <ul>
            <li v-for="item in ccf.correctivePreventiveInternal" :key="item.actionRemarkExternal">
              {{ item.actionRemarkExternal }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div id="borderline"></div>

    <br/>

    <br/>

    <!-- NO 9 -->
    <div id="borderline"></div>
    <div id="report-body2" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>9. OTORISASI KELUHAN (No. 7 & 8)<br/>COMPLAINT AUTHORIZATION (No. 7 & 8)</b></div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div style="font-weight: bold;" class="p-1">Nama<br/>Name</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div style="font-weight: bold;" class="p-1">TTD & Cap<br/>Sign & Stamp</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div style="font-weight: bold;" class="p-1">Tanggal<br/>Date</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"><br/><br/></div>
      </div>
      <div id="report-sidebar10" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.manufDirectorName}}<br/>Manufacturing Director</div>
      </div>
      <div id="report-sidebar10" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
      <div id="report-sidebar10" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
    </div>

    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">Disetujui oleh<br/>Approved by</div>
      </div>
      <div id="report-sidebar10" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.qaManagerName}}<br/>Quality and SHE Manager</div>
      </div>
      <div id="report-sidebar10" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
      <div id="report-sidebar10" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
    </div>

    <div id="report-body" class="d-flex justify-content-between">
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"><br/><br/></div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{ccf.hodName}}<br/>LM of Department in Charge</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
    </div>
    <div id="borderline"></div>
  </div>
</div>
</template>

<script>
import moment from 'moment'
import api from '../../services/api'
import { ccf } from '../../models/ccf'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export default {
  components: {
    AppLookupField, AppDatatable, AppDatePicker
  },
  data() {
    return {
      ccf: {
        ...ccf
      }
    }
  },
  async created() {
    if(this.$route.query.id !== undefined) {
      const ccfApi = api('print/ccf')
      this.ccf = await ccfApi.getWithParams(this.$route.query.id)
    }
  },
  methods: {
    close() {
    //   this.$router.push({ name: 'approvedQuality' })
    },
    async exportToPdf() {
      const input = document.getElementById('report-to-print')
      const canvas = await html2canvas(input, {
        width: 1600,
        height: 2000
      })
      const imgData = canvas.toDataURL('image/png')

      const pdf = new jsPDF('l', 'mm', 'letter')
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()

      const currentTime = Date.now()
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight)
      pdf.save(`${this.ccf.complaintNo}.pdf`)
    }
  }
}
</script>